import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './advanced-material.reducer';

export const AdvancedMaterialDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const advancedMaterialEntity = useAppSelector(state => state.advancedMaterial.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="advancedMaterialDetailsHeading">
          <Translate contentKey="coconApp.advancedMaterial.detail.title">AdvancedMaterial</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{advancedMaterialEntity.id}</dd>
          <dt>
            <span id="molecularFormula">
              <Translate contentKey="coconApp.advancedMaterial.molecularFormula">Molecular Formula</Translate>
            </span>
          </dt>
          <dd>{advancedMaterialEntity.molecularFormula}</dd>
          <dt>
            <span id="trivialName">
              <Translate contentKey="coconApp.advancedMaterial.trivialName">Trivial Name</Translate>
            </span>
          </dt>
          <dd>{advancedMaterialEntity.trivialName}</dd>
        </dl>
        <Button tag={Link} to="/advanced-material" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/advanced-material/${advancedMaterialEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AdvancedMaterialDetail;
